import type React from "react";
import {
  Carousel as ShadcnCarousel,
  CarouselContent as ShadcnCarouselContent,
  CarouselItem as ShadcnCarouselItem,
  CarouselPrevious as ShadcnCarouselPrevious,
  CarouselNext as ShadcnCarouselNext,
} from "src/shadcn/components/carousel";

const Carousel = (props: React.ComponentProps<typeof ShadcnCarousel>) => (
  <ShadcnCarousel {...props} />
);

const CarouselContent = (
  props: React.ComponentProps<typeof ShadcnCarouselContent>
) => <ShadcnCarouselContent {...props} />;

const CarouselItem = (
  props: React.ComponentProps<typeof ShadcnCarouselItem>
) => <ShadcnCarouselItem {...props} />;

const CarouselPrevious = (
  props: React.ComponentProps<typeof ShadcnCarouselPrevious>
) => <ShadcnCarouselPrevious {...props} />;

const CarouselNext = (
  props: React.ComponentProps<typeof ShadcnCarouselNext>
) => <ShadcnCarouselNext {...props} />;

export {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
};
export { useCarousel } from "src/shadcn/components/carousel";
export type { CarouselApi } from "src/shadcn/components/carousel";
